<template>
    <div class="tabs">
        <el-tabs :value="tabsActive" type="card" @tab-click="clickTab" @tab-remove="removeTab">
            <template v-for="item in tabsData">
                <el-tab-pane :name="item.name" :label="item.title" :closable="item.closable" :key="item.name"/>
            </template>
        </el-tabs>
        <el-dropdown @command="command" size="small" class="more">
            <div class="el-icon-more-outline more-icon"/>
            <el-dropdown-menu slot="dropdown" class="tabs-dropdown-menu">
                <el-dropdown-item :command="{code: 'now', name: tabsActive}" :disabled="tabsActive === '0'">关闭当前</el-dropdown-item>
                <el-dropdown-item :command="{code: 'other', name: tabsActive}"
                                  :disabled="(tabsActive === '0' && tabsData.length === 1) || (tabsActive !== '0' && tabsData.length <= 2)">
                    关闭其他
                </el-dropdown-item>
                <el-dropdown-item :command="{code: 'all'}" :disabled="tabsActive === '0' && tabsData.length <= 1">关闭全部</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
    export default {
        name: "Tabs",
        data() {
            return {
                tabsActive: '',
                tabsData: [{
                    title: '首页',
                    name: '0',
                    path: this.feUrl + '/index.html',
                    closable: false
                }]
            }
        },
        watch: {
            $route(to) {
                if (!to.meta.title) {
                    return;
                }
                this.addTab();
            },
        },
        created() {
            this.addTab();
        },
        methods: {
            //添加tab
            addTab() {
                //通过 路由 查找
                const {meta,path} = this.$route;
                let tabData = this.tabsData;
                // 标志是否已有该tab，默认false
                let tabHasAdded = false;
                //定义 tabsData 的 name 属性值
                let targetName = 0;
                // 查找是否已有该tab
                tabData.some(tab => {
                    if (tab.title === meta.title) {
                        // 已有该tab
                        tabHasAdded = true
                        // 已有该tab，直接定位到该tab;
                        this.tabsActive = tab.name;
                        return true;
                    }
                    //化为整数
                    const name = parseInt(tab.name);
                    //查找是否已有该 name 属性值
                    if (name === targetName) {
                        //已有该 name 属性值，自加
                        targetName++;
                    } else if (name > targetName){
                        // 没有该 name 属性值, 如果 name 大于 targetName，则 targetName 赋值 name + 1, 以此保证不重复
                        targetName = name + 1;
                    }
                });
                //已有该tab，直接结束
                if (tabHasAdded) return;
                //没有该tab，将 targetName 设为 String 型
                targetName = String(targetName);
                //往 tabsData 中添加数据
                tabData.push({
                    title: meta.title,
                    name: targetName,
                    path: path,
                    closable: true
                });
                //将添加的tab设为活跃状态(既选中状态)
                this.tabsActive = targetName;
            },

            //删除tabs
            removeTab(targetName) {
                //如果当前要删除的 tab 为当前活跃的 tab(既当前处于选中状态的 tab)
                if (this.tabsActive === targetName) {
                    //循环 tabsData
                    this.tabsData.some((tab, index) => {
                        //找到要删除的 tab
                        if (tab.name === targetName) {
                            //定义一个可以被选中的 tab， 优先当前 tab 的下一个，没有下一个则到上一个
                            let nextTab = this.tabsData[index + 1] || this.tabsData[index - 1];
                            if (nextTab) {
                                //跳转路由
                                this.$router.push(nextTab.path);
                            }
                            return true;
                        }
                    });
                }
                //删除要删除的tab
                this.tabsData = this.tabsData.filter(tab => tab.name !== targetName);
            },

            //tabs的点击操作
            clickTab(targetName) {
                const tab = this.tabsData.filter(tab => tab.name === targetName.name);
                if (tab[0].path === this.$route.path) {
                    return;
                }
                //路由跳转
                this.$router.push(tab[0].path);
            },
            command(command) {
                switch (command.code) {
                    // 删除当前被选中的tab
                    case 'now': {
                        this.tabsData.forEach((tab) => {
                            // 判断是否是当前tab
                            if (this.tabsActive === tab.name) {
                                // 判断是否可删除，是则删除
                                if (tab.closable) {
                                    this.removeTab(tab.name);
                                }
                            }
                        });
                        break;
                    }
                    // 删除除当前tab外的其它tab
                    case 'other': {
                        this.tabsData.forEach((tab) => {
                            //判断是否可删除
                            if (tab.closable) {
                                //如果不是当前tab则删除
                                if (command.name !== tab.name) {
                                    this.removeTab(tab.name);
                                }
                            }
                        });
                        break;
                    }
                    // 删除所有tab
                    case 'all': {
                        this.tabsData.forEach((tab) => {
                            //判断是否可删除
                            if (tab.closable) {
                                this.removeTab(tab.name);
                            }
                        });
                        break;
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .tabs {
        padding: 0 7px;
        background-color: #FFF;
        position: relative;
    }
    .tabs .el-tabs {
        border-top: 1px solid #E4E7ED;
        padding-right: 2rem;
        border-bottom: none;
    }
    .tabs .el-tabs >>> .el-tabs__nav {
        border: none!important;
    }
    .tabs .el-tabs >>> .el-tabs__item {
        height: 30px;
        line-height: 28px;
        border: 1px solid #E4E7ED!important;
        margin: 3px 3px 5px;
        padding: 0 8px!important;
        border-radius: 3px;
        background-color: #ffffff;
    }
    .tabs .el-tabs >>> .el-tabs__item {
        font-size: 12px;
    }
    .tabs .el-tabs >>> .el-tabs__item.is-active {
        border: 1px solid #409EFF;
        background: #409EFF;
        color: #FFFFFF;
    }
    .tabs .el-tabs >>> .el-tabs__item.is-active .tab-name {
        color: #FFFFFF;
    }
    .tabs .el-tabs >>> .el-tabs__header {
        margin: 0;
        border-bottom: none;
    }
    .tabs .el-tabs >>> .el-tabs__header .el-tabs__nav-prev,
    .tabs .el-tabs >>> .el-tabs__header .el-tabs__nav-next {
        line-height: 38px;
    }
    .tabs .el-tabs >>> .el-icon-close {
        line-height: 14px!important;
    }
    .tabs .el-tabs >>> .el-tabs__item.is-active {
        border: 1px solid #409EFF!important;
    }
    .tabs .el-tabs >>> .el-tabs__item.is-active::before {
        content: "";
        background: #fff;
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        position: relative;
        margin-right: 3px;
    }

    .tabs-dropdown-menu {
        padding: 5px 0;
    }
    .tabs-dropdown-menu >>> .el-dropdown-menu__item {
        font-size: 12px;
    }
    .more {
        position: absolute;
        right: 12px;
        top: 10px;
    }
    .more-icon {
        font-size: 1.2rem;
        cursor: pointer;
    }
</style>
